import { useQuery } from '@tanstack/react-query'

import { GET_SITES_API_ID, getSites } from '@/features/site/endpoints/sites'
import type { SiteListResponse } from '@/features/site/types/site'
import type { UseUserQueryResult } from '@/features/user/hooks/useUserQuery'
import type { UseQueryOptions } from '@/types/queries'

export type UseSitesQueryResult = Omit<UseUserQueryResult, 'data'> & {
  sites?: SiteListResponse[]
}
export function useSitesQuery(options?: UseQueryOptions<SiteListResponse[]>): UseSitesQueryResult {
  const { data, ...queryResult } = useQuery({
    ...options,
    queryKey: [GET_SITES_API_ID],
    queryFn: () => getSites(),
  })

  return { sites: data, ...queryResult }
}
